import React from "react";
import { motion } from "framer-motion";

const STEPS = [
    {
        num: "01",
        title: "Apply Today",
        body: "Complete our simple application. Share your goals and your commitment to authentic networking.",
    },
    {
        num: "02",
        title: "Connect Weekly",
        body: "Join Roundtable sessions to meet quality professionals. Start building real relationships immediately.",
    },
    {
        num: "03",
        title: "Grow Your Circle",
        body: "Expand into Interest Circles as you engage more. Deepen the connections that matter most.",
    },
    {
        num: "04",
        title: "Thrive Together",
        body: "Your network becomes your most valuable professional asset. Unlock premium opportunities and leadership paths.",
    },
];

const HowItWorks = () => {
    return (
        <section
            id="how"
            data-testid="membership-timeline"
            className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-36"
        >
            <div className="max-w-3xl mb-14 md:mb-20">
                <div className="text-xs uppercase tracking-[0.3em] text-[#f2c652] font-display mb-4">
                    V. How It Works
                </div>
                <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-[0.95] text-[#f6f1e1]">
                    Four steps from invited to{" "}
                    <span className="font-serif-italic font-light text-[#f2c652]">
                        in.
                    </span>
                </h2>
            </div>

            <div className="relative grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-0 md:border-t md:border-[#d4af37]/25">
                {STEPS.map((s, i) => (
                    <motion.div
                        key={s.num}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        className={`relative md:pt-10 md:pr-8 ${
                            i < STEPS.length - 1
                                ? "md:border-r md:border-[#d4af37]/15"
                                : ""
                        }`}
                        data-testid={`step-${s.num}`}
                    >
                        <div className="md:absolute md:-top-[1px] md:left-0 md:w-10 md:h-[2px] md:bg-[#f2c652]" />
                        <div className="font-display font-black text-5xl md:text-6xl bg-gradient-to-br from-[#f2c652] to-[#d4af37] bg-clip-text text-transparent tracking-tighter mb-4">
                            {s.num}
                        </div>
                        <h3 className="font-display font-bold text-xl md:text-2xl text-[#f6f1e1] tracking-tight mb-3">
                            {s.title}
                        </h3>
                        <p className="text-[#f6f1e1]/55 font-body text-sm leading-relaxed max-w-xs">
                            {s.body}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default HowItWorks;
